import React, { FC, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'

type Props = {
    displayText: any
    onClick: any
}

export const AncientTabButtonCreate: React.FC<Props> = ({ displayText, onClick }) => {

    return (
        <div className="mb-5">
            <div className="cursor-pointer" onClick={onClick}>
                <div className="d-flex align-items-center rounded p-5">
                    <span className="svg-icon svg-icon-info me-5">
                        <KTSVG path="/media/icons/duotune/general/gen041.svg" className="svg-icon-muted svg-icon-2hx" />
                    </span>
                    <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 text-hover-primary fs-6 keychainify-checked">{displayText}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
